import { createSignal } from "solid-js"
import { Box } from "@/designSystem/components/box"
import { Button } from "@/designSystem/components/button"
import { Text } from "@/designSystem/components/text"
import { graphql } from "@/graphql"
import { useI18nContext } from "@/i18n/i18n-solid"
import {
  createMutationWithErrorHandling,
  ErrorFragment,
} from "@/lib/graphql-mutation-helpers"
import { tierSelectionContainerClass } from "./tier-selection.css"

interface SubscriptionPromptProps {
  userId: string
  postId?: string
  subscriptionId?: string
  onSuccess: () => void
  onError?: (error: unknown) => void
  tiers?: unknown[]
  publicationId?: string
  publication?: unknown
  requiredTierIds?: string[]
  currentTierName?: string
}

const SubscribeToMutation = graphql(
  `mutation SubscribeFromPrompt($targetUserId: String!, $postId: String) {
    subscribeTo(targetUserId: $targetUserId, postId: $postId) {
      __typename
      ... on MutationSubscribeToSuccess {
        data {
          id
        }
      }
      ...ErrorFragment
    }
  }`,
  [ErrorFragment],
)

export function SubscriptionPrompt(props: SubscriptionPromptProps) {
  const { LL } = useI18nContext()
  const [completed, setCompleted] = createSignal(Boolean(props.subscriptionId))
  const [state, subscribe] = createMutationWithErrorHandling(
    SubscribeToMutation,
    "subscribeTo",
  )

  async function handleSubscribe() {
    if (completed()) {
      props.onSuccess()
      return
    }

    const result = await subscribe({
      targetUserId: props.userId,
      postId: props.postId ?? null,
    })

    if (!result.success) {
      props.onError?.(result.error)
      return
    }

    setCompleted(true)
    props.onSuccess()
  }

  return (
    <div class={tierSelectionContainerClass}>
      <Box flexDirection="column" gap="16" alignItems="center">
        <Text fontSize="h3" fontWeight="500" color="sand900">
          {completed()
            ? LL().subscriptions.subscribed()
            : LL().auth.subscribe()}
        </Text>
        <Text fontSize="m" color="sand600" textAlign="center">
          {LL().auth.getUpdates()}
        </Text>
        <Button hue="amber" onClick={handleSubscribe} active={state.fetching}>
          {completed() ? LL().common.done() : LL().auth.subscribe()}
        </Button>
      </Box>
    </div>
  )
}
